import React, {FormEvent, memo, useCallback, useEffect, useState} from "react"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import {useHistory} from "react-router-dom"
import backIcon from "../../../../../assets/images/icons/alarm/cancel.png"
import {useRPC} from "../../../../../hooks/rpc"
import "./index.scss"

export const BrightnessTestScreen = memo(function BrightnessTestScreen() {
    const history = useHistory()
    const [rpc] = useRPC()
    const [rangeValue, setRangeValue] = useState(100)
    const [testStep, setTestStep] = useState(false)
    const [timer, setTimer] = useState(23)
    const [intervalId, setIntervalId] = useState(null)

    const onChangeBrightness = useCallback((e: FormEvent<HTMLInputElement>) => {
        // @ts-ignore
        const newValue = e.target.valueAsNumber
        setRangeValue(newValue)
    }, [])

    const onClickStartTest = useCallback(() => {
        setTestStep(p => !p)
        rpc.startScreenBrightnessTest(100)
        setTimer(23)

        if (intervalId) {
            clearInterval(intervalId)
        }

        const processTime = setInterval(() => {
            setTimer(prevTime => {
                if (prevTime > 1) {
                    return prevTime - 1
                } else {
                    clearInterval(processTime)
                    return 23
                }
            })
        }, 1000)
        setIntervalId(processTime)
        return () => clearInterval(processTime)
    }, [rpc, intervalId])

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [intervalId])

    useEffect(() => {
        let value = rangeValue
        if (testStep) {
            const interval = setInterval(() => {
                if (value >= 1) {
                    value -= 50
                    setRangeValue(value)
                } else if (value === 0) {
                    const tOut = setTimeout(() => {
                        setTestStep(false)
                        setRangeValue(0)
                    }, 3000)
                    return () => clearTimeout(tOut)
                }
                rpc.startScreenBrightnessTest(value)
            }, 5000)
            return () => clearInterval(interval)
        } else {
            if (value !== 100) {
                value = 50
                setRangeValue(value)
                rpc.startScreenBrightnessTest(value)
                const interval = setInterval(() => {
                    value += 50
                    setRangeValue(value)
                    rpc.startScreenBrightnessTest(value)
                }, 5000)
                return () => clearInterval(interval)
            } else {
                setRangeValue(100)
            }
        }
    }, [rpc, testStep, rangeValue])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <div className="brightness-test-container">
                <div className="brightness-color-test">
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
                <div className="brightness-test-actions">
                    <div className="brightness-input-range">
                        <img src={backIcon} alt="" onClick={() => history.push("/settings/advanced-settings/test")} />
                        <input
                            type="range"
                            min={0}
                            max={100}
                            step={50}
                            value={rangeValue}
                            disabled={true}
                            onChange={onChangeBrightness}
                        />
                        <span>{rangeValue}</span>
                        <div className="brightness-timer">{timer} sn</div>
                    </div>
                    <button onClick={onClickStartTest} disabled={testStep || rangeValue !== 100}>
                        Testi Başlat
                    </button>
                </div>
            </div>
        </PasswordContainer>
    )
})
